import { FormattedMessage, injectIntl } from "react-intl";
import { compose, pure } from "recompose";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Queries from "../../../queries/queries2";
import React from "react";
import { graphql } from "react-apollo";
import moment from "moment";
import { withRouter } from "react-router-dom";

const toUpdateNotifications = (
  <Tooltip id="ids_refresh">
    <FormattedMessage id="ids_refresh" />
  </Tooltip>
);

const data = graphql(Queries.GET_BANK_ACCOUNT, {
  options: ({ id }) => {
    let filter = { isDeleted: false };
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        skip: 0,
        first: 1000,
        id,
        filter
      }
    };
  },
  props: ({ data }) => ({
    data,
    loadMorePayments: () => {
      if (!data.bankAccount) return;

      return data.fetchMore({
        variables: {
          skip: data.bankAccount.bankTransactions.length,
          first: 1000
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }
          return Object.assign({}, previousResult, {
            bankAccount: {
              ...previousResult.bankAccount,
              bankTransactions: [
                ...previousResult.bankAccount.bankTransactions,
                ...fetchMoreResult.bankAccount.bankTransactions
              ]
            }
          });
        }
      });
    }
  })
});

let PaymentLastUpdate = ({ data, id, companyId, intl, locale, onRefreshAccount, disabled }) => {
  if (
    data.bankAccount &&
    data.bankAccount.providerAccount &&
    data.bankAccount.providerAccount.dateLastUpdate
  ) {

    const showRefresh = !(data.bankAccount.providerAccount.importedAccount) && onRefreshAccount;
    return (
      <div align="left" valign="bottom">
        <FormattedMessage id="ids_lastUpdate" />
        <FormattedMessage id="ids_colon" />{" "}
        {moment(data.bankAccount.providerAccount.dateLastUpdate).format("L")}
        {" "}
        {showRefresh && (
          <OverlayTrigger placement="top" overlay={toUpdateNotifications}>
            <i className={!!!disabled ? "fa fa-lg fa-refresh text-info" : "fa fa-lg fa-refresh text-muted"}
              onClick={() => !!!disabled
                ? onRefreshAccount({ bankAccount: data.bankAccount })
                : console.log("disabled...")
              }
            />
          </OverlayTrigger>
        )}
      </div>
    );
  } else {
    return <div />;
  }
};

PaymentLastUpdate = compose(
  data,
  pure
)(PaymentLastUpdate);

export default withRouter(injectIntl(PaymentLastUpdate));
